<template>
  <div class="loading__main">
    <div class="login__main">
      <div class="login__col1">
        <div class="login__col1Body">
          <div class="signup__back" @click="onLogin">
            <img :src="require('../../assets/svg/back1.svg')" alt="back" />
          </div>
          <div class="login__header">
            <router-link to="/" class="login__headingImage">
              <img
                :src="require('../../assets/photos/khaanpinRed.png')"
                alt="khaanpin"
              />
            </router-link>

            <div class="login__subHeader">
              <span> FOODS . LIQUORS . CAKES</span>
              <span> 24 HOURS</span>
            </div>
          </div>

          <div class="login__body">
            <div class="isShow" v-show="isShow">
              {{ this.resMessage }}
            </div>

            <div v-if="loading" class="loading__loading"><Loading /></div>

            <div v-else>
              <form @submit="handleSubmit" v-if="!isShow">
                <input
                  placeholder=" Enter Your Registered Email."
                  autocomplete="off"
                  v-model="email"
                  class="login__input"
                  @change="testEmail"
                />

                <div v-if="this.errors" class="errors">{{ this.errors }}</div>
                <div v-if="this.resErrMessage" class="errors">
                  {{ this.resErrMessage }}
                </div>

                <!-- <input
                placeholder="Enter Your Password"
                type="password"
                autocomplete="off"
                v-model="password"
                class="login__input"
              /> -->
                <button class="login__buttonSimple" @submit="handleSubmit">
                  Submit
                </button>
              </form>
            </div>

            <!-- <span class="login__OR"> OR</span> -->
            <!-- <div class="login__options">
              <div class="login__signup">
                <span> Don't have an account?</span>
                <span>
                  <router-link to="/register" class="login__link">
                    Sign up
                  </router-link>
                </span>
              </div>
            </div> -->
          </div>

          <div class="login__loc">
            <span> Kathmandu </span>
            <span> /</span>
            <span> Pokhara</span>
          </div>
        </div>
      </div>

      <div class="login__col2">
        <a-carousel autoplay fade>
          <div class="login__carousel">
            <img
              :src="require('../../assets/photos/pizza.jpg')"
              alt="khaanpin"
            />
            <div class="login__imageText">
              <span>Amazing 50-50 Pizza.</span>
              <span
                >Our 50-50 pizza are the best in the town. No one can
                deny!</span
              >
            </div>
          </div>
          <div class="login__carousel">
            <img
              :src="require('../../assets/photos/chicken.jpg')"
              alt="khaanpin"
            />
            <div class="login__imageText">
              <span>Amazing 50-50 Pizza.</span>
              <span
                >Our 50-50 pizza are the best in the town. No one can
                deny!</span
              >
            </div>
          </div>
        </a-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../../router";

import Loading from "../../components/Loading/Loading.vue";

export default {
  name: "ForgetPassword",
  components: {
    Loading,
  },
  data() {
    return {
      email: "",
      isShow: false,
      loading: false,
      resMessage: "",
      errors: "",
      resErrMessage: "",
      isError: false,
      reg: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },

  watch: {
    email() {
      this.testEmail();
    },
  },
  methods: {
    testEmail() {
      if (this.email == null || this.email == "") {
        this.errors = "Email Field is empty";
        this.isError = true;
        this.loading = false;
      } else if (!this.reg.test(this.email)) {
        this.errors = "Email is not valid";
        this.isError = true;
        this.loading = false;
      } else if (this.reg.test(this.email)) {
        this.errors = "";
        this.isError = false;
      }
      // console.log(this.errors, "err");
    },

    handleSubmit(e) {
      e.preventDefault();

      if (this.isError == false) {
        this.loading = true;

        const _data = {
          email: this.email,
        };
        axios
          .post("https://manager.khaanpin.com/apiv2/sendpwdtoemail/", _data)
          .then((res) => {
            if (res.data.error === false) {
              this.loading = false;
              this.resMessage = res.data.data;
              (this.isShow = true),
                this.$notification.success({
                  message: "Success ",
                  description: res.data.data,
                });
            } else {
              this.loading = false;
              this.resErrMessage = "Please enter the valid email";

              this.$notification.error({
                message: "Try Again. ",
                description: "Please enter the valid email",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      }

      //   console.log(_data, 'data')
    },
    onLogin() {
      router.push("/p/login");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.ant-carousel >>> .slick-slide {
  overflow: hidden;
}

.ant-carousel >>> .slick-dots li button {
  background-color: transparent;
}

.ant-carousel >>> .slick-dots li.slick-active button {
  background: transparent;
}

.login__main {
  /* border: 1px solid red; */
  display: flex;
  font-family: "Montserrat", sans-serif;
  /* height: 100vh; */
  /* background-color: red; */
}

.login__col1 {
  flex: 6;
  /* background-color: #f2f2f2; */
  background: url("../../assets/background/login.jpg") repeat-x;
  background-size: contain;
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* min-height: 50vh; */
  /* height: 100vh; */
}

.login__col1Body {
  /* border: 1px solid black; */
  padding: 11% 10%;
  background-color: #ffffffdd;
  border-radius: 12px;
  position: relative;
  /* margin: 100px 50px; */
  box-shadow: 0 0 10px 0 rgb(0 0 0 / 4%);
}

.login__col2 {
  flex: 6;

  height: 90vh;

  box-shadow: 0 3px 6px #00000029, 0 3px 6px #0000003b;
  overflow: hidden;
}
.login__carousel {
  height: 90vh;

  /* position: relative; */
}

.login__imageText {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  color: rgb(228, 228, 228);
  /* top: 50%; */
  bottom: 40%;
  width: 100%;
  padding-left: 12px;
  padding-bottom: 10px;
  /* background-image: linear-gradient(transparent, #1b1b1bdc, #020202c0); */
  /* bottom: 0%; */
}

.login__imageText > span:nth-child(1) {
  font-size: 40px;
  font-weight: bolder;
  text-shadow: 0 0 6px rgb(100, 100, 100);
}

.login__imageText > span:nth-child(2) {
  font-size: 25px;
  font-weight: bolder;
  text-shadow: 0 0 6px rgba(0, 0, 0);
}

.login__carousel > img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  box-shadow: 0 0 8px 0 rgb(0 0 0 / 10%);
  /* padding: 50px; */
}

.login__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 18px;
}

.login__subHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
}

.login__subHeader > span {
  color: #000000;
}

.login__headingImage > img {
  height: 100px;
}

.login__header > span {
  font-size: 25px;
  font-weight: bolder;
}

.errors {
  /* border :1px solid black; */
  width: 100%;
  text-align: center;
  font-size: 11px;
  font-weight: bolder;
  color: #ed2027;
  margin-top: -10px;
  margin-bottom: 10px;
}

.loading__loading {
  height: 7vh;
}

.login__body > form {
  height: 7vh;
}

.isShow {
  /* border: 1px solid black; */
  font-size: 16px;
  color: rgb(56, 56, 56);

  font-weight: bolder;
}

.login__body {
  display: flex;
  flex-direction: column;
  margin: 6% 0;
}

.login__buttonSimple {
  background-color: #ed2027;
  color: #ffffff;
  border: none;
  padding: 12px 0;
  border-radius: 12px;
  font-weight: bolder;
  transition: 0.3s all;
  /* border: 1px solid black; */
  width: 100%;
}

.login__body > button:hover {
  background-color: #c20b0b;
  cursor: pointer;
}

.login__input {
  /* outline:none; */
  width: 100%;
  margin-bottom: 15px;
  padding: 0.8em 15px;
  border: 1px solid #808080;
  border-radius: 12px;
  background-color: #ffffff !important;
  outline: none;
  text-align: center;
}

.login__OR {
  text-align: center;
  margin: 20px 0;
}

::placeholder {
  color: grey;
  text-align: center;
}

.login__options {
  display: flex;
  flex-direction: column;
  /* margin: 20px 0; */
}

.login__button {
  /* width: 29rem; */
  /* background-color: red; */
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d4;
  /* margin: 5px 0; */
  margin-bottom: 18px;
  border-radius: 18px;
  padding: 10px 0;
  cursor: pointer;
  transition: 0.3s all;
}

.login__buttonfacebook {
  /* width: 29rem; */
  background-color: #3a6acc;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d4;
  /* margin: 5px 0; */
  margin-bottom: 18px;
  border-radius: 18px;
  padding: 10px 0;
  cursor: pointer;
  transition: 0.3s all;
}

.login__buttonfacebook:hover {
  background-color: #1f53bb;
}

.login__button:hover {
  background-color: #f2f2f2;
}

.login__button > img,
.login__buttonfacebook > img {
  height: 35px;
  width: 35px;
  border-radius: 15px;
}

.login__button > button {
  border: none;
  color: #000000;
  font-weight: bolder;
  background-color: transparent;
  font-size: 15px;
  margin-left: 10px;
  cursor: pointer;
}

.login__buttonfacebook > button {
  border: none;
  color: white;
  font-weight: bolder;
  background-color: transparent;
  font-size: 15px;
  margin-left: 10px;
  cursor: pointer;
}

.login__button > button:hover {
  background-color: #f2f2f2;
}

.login__signup {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login__link {
  color: #363636;
  font-weight: bolder;
  margin-left: 5px;
  cursor: pointer;
}

.login__link:hover {
  color: #1f1f1f;
  text-decoration: underline;
}

.login__loc {
  /* border: 1px solid black; */
  text-align: center;
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.login__loc > span:nth-child(1) {
  margin-right: 5px;
}

.login__loc > span:nth-child(1):hover {
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
}

.login__loc > span:nth-child(3) {
  margin-left: 5px;
}

.login__loc > span:nth-child(3):hover {
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
}

@media only screen and (max-width: 1400px) {
  .login__col1 {
    background: url("../../assets/background/login.jpg") repeat-x;
    background-size: cover;
  }

  .login__headingImage > img[data-v-15717af5] {
    height: 83px;
  }

  .login__col1Body {
    padding: 5% 6%;
    margin: 0.5% 0;
    width: 100%;
  }
  .login__body > input {
    /* outline: none; */
    width: 18rem;
  }

  .login__OR {
    text-align: center;
    margin: 6px 0;
  }

  .login__button {
    padding: 7px 0;
    border-radius: 10px;
  }

  .login__buttonfacebook {
    /* margin: 5px 0; */
    border-radius: 10px;
    padding: 8px 0;
  }

  .login__button > img,
  .login__buttonfacebook > img {
    height: 29px;
    width: 28px;
    border-radius: 12px;
  }

  .login__body > button {
    padding: 14px 0;
  }

  .login__imageText > span:nth-child(1) {
    font-size: 35px;
    font-weight: bolder;
    /* text-transform: uppercase; */
  }

  .login__imageText > span:nth-child(2) {
    font-size: 18px;
  }

  @media only screen and (max-width: 850px) {
    .login__col2 {
      display: none;
    }

    .login__col1Body {
      padding: 5% 8%;
      width: 100%;
    }

    .login__body > input {
      /* outline: none; */
      width: 15rem;
    }

    .login__button {
      margin-bottom: 15px;
    }
    .login__headingImage > img {
      height: 66px;
    }
  }
}
</style>
